import CrmServiceCollection from "@/collections/CrmServiceCollection"
import CustomerCoordModel from "@/models/crm/CustomerCoordModel"

export default class CustomerCoordCollection extends CrmServiceCollection {

  // Model that is contained in this collection.
  model() {
    return CustomerCoordModel
  }

}
